import styled from 'styled-components';

export const RoomInfoWrapper = styled.div`
  border: 1px solid #dee3ee;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr;
  padding: 20px;
`;
